"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.isempty"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _lodash3 = _interopRequireDefault(require("lodash.clonedeep"));

var _common = require("../../../common");

var _ColorInputSection = _interopRequireDefault(require("../ColorInputSection/ColorInputSection"));

require("./styles/_color-palettes.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NEW_COLOR = function NEW_COLOR() {
  return {
    key: (0, _v.default)(),
    hexCode: '#FFF',
    name: ''
  };
};

var NEW_COLOR_PALETTE = function NEW_COLOR_PALETTE() {
  return {
    key: (0, _v.default)(),
    name: '',
    colors: [NEW_COLOR()]
  };
};

var ColorPalettes = /*#__PURE__*/function (_Component) {
  _inherits(ColorPalettes, _Component);

  function ColorPalettes(props) {
    var _this;

    _classCallCheck(this, ColorPalettes);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorPalettes).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateInputField", (0, _lodash.default)(function (fieldName) {
      return function (result) {
        _this.setState(_defineProperty({}, fieldName, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "updateColorInputField", (0, _memoizeOne.default)(function (index, fieldName) {
      return function (result) {
        _this.setState(function (_ref) {
          var prevColorPalettes = _ref.colorPalettes;
          var colorPalettes = (0, _lodash3.default)(prevColorPalettes);
          var colorPalette = colorPalettes[index];
          colorPalette[fieldName] = (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result);
          return {
            colorPalettes: colorPalettes
          };
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleAddMoreButtonClick", (0, _lodash.default)(function (index) {
      return function () {
        _this.setState(function (_ref2) {
          var prevColorPalettes = _ref2.colorPalettes;
          var colorPalettes = (0, _lodash3.default)(prevColorPalettes);
          var colorPalette = colorPalettes[index];
          var colors = colorPalette.colors;
          colors.push(NEW_COLOR());
          return {
            colorPalettes: colorPalettes
          };
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleSaveColor", (0, _lodash.default)(function (colorPaletteIndex) {
      return function (colorIndex) {
        return function (_ref3) {
          var hex = _ref3.hex,
              label = _ref3.label;

          _this.setState(function (_ref4) {
            var prevColorPalettes = _ref4.colorPalettes;
            var colorPalettes = (0, _lodash3.default)(prevColorPalettes);
            var colorPalette = colorPalettes[colorPaletteIndex];
            var colors = colorPalette.colors;
            colors[colorIndex] = _objectSpread({}, colors[colorIndex], {
              hexCode: hex,
              name: label
            });
            return {
              colorPalettes: colorPalettes
            };
          });
        };
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleRemoveClick", (0, _lodash.default)(function (colorPaletteIndex) {
      return function (colorIndex) {
        return function () {
          _this.setState(function (_ref5) {
            var prevColorPalettes = _ref5.colorPalettes;
            var colorPalettes = (0, _lodash3.default)(prevColorPalettes);
            var colors = colorPalettes[colorPaletteIndex].colors;
            colors.splice(colorIndex, 1);

            if (colors.length === 0) {
              colorPalettes.splice(colorPaletteIndex, 1);
            }

            return {
              colorPalettes: colorPalettes
            };
          });
        };
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleAddNewSection", function () {
      _this.setState(function (_ref6) {
        var prevColorPalettes = _ref6.colorPalettes;
        return {
          colorPalettes: [].concat(_toConsumableArray(prevColorPalettes), [NEW_COLOR_PALETTE()])
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaveAndContinue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$state, colorPalettesOverview, colorPalettes, _this$props, goToNextWizardStage, updateSubBrand;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, colorPalettesOverview = _this$state.colorPalettesOverview, colorPalettes = _this$state.colorPalettes;
              _this$props = _this.props, goToNextWizardStage = _this$props.goToNextWizardStage, updateSubBrand = _this$props.updateSubBrand;
              updateSubBrand({
                colorPalettesOverview: colorPalettesOverview,
                colorPalettes: colorPalettes.map(function (_ref8, paletteIndex) {
                  var key = _ref8.key,
                      palette = _objectWithoutProperties(_ref8, ["key"]);

                  return _objectSpread({}, palette, {
                    position: paletteIndex,
                    colors: palette.colors.map(function (_ref9, colorIndex) {
                      var colorKey = _ref9.key,
                          color = _objectWithoutProperties(_ref9, ["key"]);

                      return _objectSpread({}, color, {
                        position: colorIndex
                      });
                    })
                  });
                })
              });
              return _context.abrupt("return", void goToNextWizardStage());

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    var _props$subBrand = props.subBrand,
        _colorPalettes = _props$subBrand.colorPalettes,
        _colorPalettesOverview = _props$subBrand.colorPalettesOverview;
    _this.state = {
      colorPalettesOverview: _colorPalettesOverview,
      colorPalettes: (0, _lodash2.default)(_colorPalettes) ? [NEW_COLOR_PALETTE()] : _colorPalettes
    };
    return _this;
  }

  _createClass(ColorPalettes, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          colorPalettes = _this$state2.colorPalettes,
          colorPalettesOverview = _this$state2.colorPalettesOverview;
      return _react.default.createElement("div", {
        className: "colors__container"
      }, _react.default.createElement(_common.PageTitle, {
        title: "Color Palette"
      }), _react.default.createElement("section", null, _react.default.createElement(_common.OverviewSummary, {
        iconLabel: "Overview",
        textLabel: "SUMMARY",
        placeholder: "Enter Summary",
        defaultValue: colorPalettesOverview,
        handleChange: this.updateInputField('colorPalettesOverview')
      })), colorPalettes.map(function (_ref10, index) {
        var subBrandGroupId = _ref10.subBrandGroupId,
            key = _ref10.key,
            name = _ref10.name,
            colors = _ref10.colors;
        return _react.default.createElement(_ColorInputSection.default, {
          key: subBrandGroupId || key,
          titleName: name,
          colors: colors,
          index: index,
          handleChangeTitle: _this2.updateColorInputField(index, 'name'),
          handleAddMoreButtonClick: _this2.handleAddMoreButtonClick(index),
          titlePlaceHolder: index === 0 ? 'Primary Color' : 'Secondary Color',
          handleSaveColor: _this2.handleSaveColor(index),
          handleRemoveClick: _this2.handleRemoveClick(index)
        });
      }), _react.default.createElement(_uiKit.LinkButton, {
        className: "colors__container__new-section",
        onClick: this.handleAddNewSection
      }, "Tap to add New Section"), _react.default.createElement("section", null, _react.default.createElement(_uiKit.Button, {
        className: "colors__container__save-continue save-button",
        onClick: this.handleSaveAndContinue
      }, "Save & Continue")));
    }
  }]);

  return ColorPalettes;
}(_react.Component);

var _default = ColorPalettes;
exports.default = _default;